const FCM = {
	key: "AAAAG0Gzv94:APA91bH6GNiGtynlSrDzhjw32YI6AT6ENClsH4ViILJxa-pxxdgYuQFN2x-25GdAmK3yHWPJ8N5zyW6263E3PuqRfQGT1oCyC84HBOrbL1WsNLZ1tJB6OKzeRo0sthpsRrE2GFSfM2v7"
}

export default FCM;